export const isString = (value: unknown): value is string => {
  return 'string' === typeof value
}
